// Generated by CoffeeScript 1.10.0
(function() {
  var Block, BlockList, convertNewlinesToHTML;

  convertNewlinesToHTML = require('./htmlutil').convertNewlinesToHTML;


  /*
  A list of HTML blocks with potentially differing transformations.
   */

  BlockList = (function() {

    /*
    Creates a new BlockList.
     */
    function BlockList() {
      this.blocks = [];
    }


    /*
    Appends HTML to the list.
    
    @param [String] html
      the HTML to append
    @param [Boolean] newlines
      whether newlines should be converted to HTML using {~convertNewlinesToHTML}
    @param [Boolean] smileys
      whether smileys should be converted to some other form
     */

    BlockList.prototype.append = function(html, newlines, smileys) {
      var lastBlock;
      if (newlines == null) {
        newlines = true;
      }
      if (smileys == null) {
        smileys = true;
      }
      if (this.blocks.length > 0) {
        lastBlock = this.blocks[this.blocks.length - 1];
        if (lastBlock.newlines === newlines && lastBlock.smileys === smileys) {
          lastBlock.html += html;
          return lastBlock;
        }
      }
      return this.blocks.push(new Block(html, newlines, smileys));
    };


    /*
    Appends HTML that has newlines escaped and smileys replaced.
    
    @param [String] html
      the HTML to append
     */

    BlockList.prototype.appendHTML = function(html) {
      return this.append(html);
    };


    /*
    Appends HTML that is left as-is, with no new lines replaced and no smileys
    replaced.
    
    @param [String] html
      the HTML to append
     */

    BlockList.prototype.appendRawHTML = function(html) {
      return this.append(html, false, false);
    };


    /*
    Converts every that has been pended to the BlockList to its final HTML form.
    
    @param [BBCodeParser] parser
      the BBCodeParser to use for translating smileys, or `null` to skip that step
    @return [String]
      the translated HTML
     */

    BlockList.prototype.toHTML = function(parser) {
      var block, html, i, len, ref;
      if (this.firstBlock === null) {
        return "";
      }
      html = [];
      ref = this.blocks;
      for (i = 0, len = ref.length; i < len; i++) {
        block = ref[i];
        html.push(block.toHTML(parser));
      }
      return html.join('');
    };

    return BlockList;

  })();


  /*
  Internal representation of a single block within the {BlockList}. Generally
  speaking there should be no reason to directly use this class. Instead use the
  {BlockList#append} method.
  @private
   */

  Block = (function() {

    /*
    Constructs a new block.
    
    @param [String] html
      the HTML to append
    @param [Boolean] newlines
      whether newlines should be converted to HTML using {~convertNewlinesToHTML}
    @param [Boolean] smileys
      whether smileys should be converted to some other form
    @param [Boolean] paragraph
      in the future (not yet) whether or not the text should be surrounded by a
      paragraph or not (intended for use inside an `<li>` or possibly table cells
      or other occassions where always surrounding with a paragraphs doesn't make
      sense). The feature is not implemented yet and this flag is ignored.
     */
    function Block(html1, newlines1, smileys1, paragraph) {
      this.html = html1;
      this.newlines = newlines1 != null ? newlines1 : true;
      this.smileys = smileys1 != null ? smileys1 : true;
      this.paragraph = paragraph != null ? paragraph : true;
    }


    /*
    Execute the active translatings, returning the result.
    
    @param [BBCodeParser] parser
      the BBCodeParser to use for translating smileys, or `null` to skip that step
    @return [String]
      the translated HTML
     */

    Block.prototype.toHTML = function(parser) {
      var text;
      text = this.html;
      if (this.newlines) {
        text = convertNewlinesToHTML(text);
      }
      if (this.smileys && (parser != null)) {
        text = parser.replaceSmileys(text);
      }
      return text;
    };

    return Block;

  })();

  module.exports = BlockList;

  BlockList.Block = Block;

}).call(this);



/*****************
 ** WEBPACK FOOTER
 ** ./~/bitter-bbcode/lib/blocks.js
 ** module id = ./node_modules/bitter-bbcode/lib/blocks.js
 ** module chunks = 1
 **/